module.exports = __webpack_public_path__ + "img/why-bg.e6c95daa.png";